module.exports = __webpack_public_path__ + "static/media/GothamBold.db33e70b.ttf";